<template>
  <b-row>
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.agreements.form.agreementsPromotions")}}: </span>
    </b-col>
    <b-col>
      <template v-if="data.packagePromotions && data.packagePromotions.length > 0">
        <b-row v-for="(item, index) in data.packagePromotions" :key="index">
          <b-col>
            <model-select v-model="data.packagePromotions[index].promotion" :options="promotionsOptions" :placeholder="$t('views.agreements.form.select')" required class="mb-3" name="item">
            </model-select>
          </b-col>
          <b-col>
            <button type="button" class="btn btn-danger" @click="removePromotion(index)">{{ $t('buttons.delete') }}</button>
          </b-col>
        </b-row>
      </template>
      <b-row>
        <b-col>
          <b-button class="btn btn-primary" @click="addNewPromotion()">{{ $t('views.agreements.form.addNewPromotion') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import remove from '@/utils/remove'

export default {
  name: 'PackagePromotions',
  components: {
    ModelSelect
  },

  props: ['data', 'violations'],

  computed: {
    ...mapGetters({
      promotionsOptions: 'packages/list/getPromotions'
    })
  },

  created () {
    this.fetchPromotions()
  },

  methods: {
    addNewPromotion () {
      let item = {}
      this.data.packagePromotions.push(item)
    },
    removePromotion (index) {
      let currentPromotion = this.data.packagePromotions[index]
      if (currentPromotion['@id']) {
        remove(currentPromotion['@id'], () => {
          this.data.packagePromotions.splice(index, 1)
        })
      } else {
        this.data.packagePromotions.splice(index, 1)
      }
    },
    ...mapActions({
      fetchPromotions: 'packages/list/fetchPromotions'
    })
  }
}
</script>
